import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import './classes/Login.css';
import { configData } from "../config";
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faExclamationCircle, faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";

const Login = () => {

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const app_url = configData.APP_URL;
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

// const navigate = useNavigate();
// useEffect(() => {
//         const token = localStorage.getItem("token");
//         if (token) {
//             const user = JSON.parse(localStorage.getItem("user")) || {};
//             if (user.role === "admin") {
//                 navigate("/inventory-management"); 
//             } else {
//                 navigate("/purchase-order");
//             }
//         }
//     }, [navigate]);

    const handleLogin = async (event) => {
        event.preventDefault();

        const payload = {
            username: formData.username,
            password: formData.password
        };
        
        try {
            const res = await fetch(app_url + "site/loginapi", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (data.success) {
                setErrors('');
                alert(`Logged in successfully as ${data.user?.username}`);
                // localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));

                if (data.user?.role === '1') {
                    window.location.href = "/sales-report"; 
                } else {
                    window.location.href = "/sales"; 
                }
                // if (!data.user?.company_id) {
                //     window.location.href = "/company-setup";
                // } else {
                //     if (data.user?.role === '1') {
                //         window.location.href = "/sales-report"; 
                //     } else {
                //         window.location.href = "/sales"; 
                //     }
                // }
                setShowPassword(false);
            } else {
            if (typeof data.message === "object") {
                const errorText = Object.values(data.message)
                    .flat()
                    .join("<br/>");
                setErrors(errorText);
            } else {
                setErrors(data.message);
            }
        }
        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        }
    };

    return (
        <div className="pos-login-main">
            <Helmet><title>Login</title></Helmet>
            <div className="login-main">
                <div className="login-container">
                    <div className="login-head-container">
                        <img src="/images/icon.png" className="login-logo" />
                        <h2 className="login-heading">Welcome Back</h2>
                        <p className="login-sub-head">Sign in to your account</p>
                    </div>

                    {Object.keys(errors).length > 0 && (
                        <div className="login-error-message-container">
                        <p className="login-error-message">
                            <FontAwesomeIcon icon={faExclamationCircle} className="login-error-message-icon" />
                            <span dangerouslySetInnerHTML={{__html: errors}}></span>
                        </p>
                        </div>
                    )}
                    <form onSubmit={handleLogin}>
                        <div className="login-form-field">
                            <label htmlFor="username">
                                Username
                            </label>
                            <div className="login-input-container">
                                <span className="login-input-icon-container">
                                    <FontAwesomeIcon icon={faUser} />
                                </span>
                                <input
                                    id="username" 
                                    type="text" 
                                    name="username" 
                                    placeholder="Enter your username" 
                                    required
                                    tabIndex={1}
                                    onChange={handleChange}
                                    value={formData.username}
                                />
                            </div>
                        </div>
                        <div className="login-form-field">
                            <label htmlFor="password">
                                Password
                            </label>
                            <div className="login-input-container">
                                <span className="login-input-icon-container">
                                    <FontAwesomeIcon icon={faLock} />
                                </span>
                                <input 
                                    id="password" 
                                    type={showPassword ? "text" : "password" }
                                    name="password" 
                                    placeholder="••••••••" 
                                    required
                                    tabIndex={1}
                                    onChange={handleChange}
                                    value={formData.password}
                                />
                                <span className="password-toggle-icon" onClick={() => setShowPassword((prev) => !prev)}>
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </span>
                            </div>
                        </div>

                        <button 
                            type="submit" 
                            className="login-form-submit"
                        >
                            Sign In
                        </button>
                    </form>
                    <div className="login-info-content">
                        {/* © 2026 ShopLite Cloud.  */}
                        All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Login;